(function () {
  function patchCartDrawerRelatedProducts() {
    const Cls = customElements.get('cart-drawer-related-products');
    if (!Cls) return;

    const originalLoad = Cls.prototype.loadProducts;
    const originalSetReady = Cls.prototype.setReady;
    const inFallback = new WeakSet();

    Cls.prototype.loadProducts = function () {
      const url = this.dataset.url;
      const hasProducts = this.querySelector('.horizontal-product-card, .vertical-product-card');

      if (url && url.includes('intent=complementary')) {
        inFallback.delete(this);
        if (hasProducts) {
            this.prevUrl = url;
            return;
        }
      }

      return originalLoad.call(this);
    };

    Cls.prototype.setReady = function (isReady) {
      originalSetReady.call(this, isReady);

      if (isReady) {
        inFallback.delete(this);
        return;
      }

      if (
        !inFallback.has(this) &&
        this.dataset.url &&
        this.dataset.url.includes('intent=complementary')
      ) {

        const fallbackUrl = this.dataset.url.replace('intent=complementary', 'intent=related');
        inFallback.add(this);
        this.prevUrl = null;
        this.dataset.url = fallbackUrl;
        originalLoad.call(this);
      }
    };
  }

  if (customElements.get('cart-drawer-related-products')) {
    patchCartDrawerRelatedProducts();
  } else {
    customElements.whenDefined('cart-drawer-related-products').then(patchCartDrawerRelatedProducts);
  }
})();